import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import appConfig from './appConfig.ts'
import { setupAuth } from './auth'

let app = createApp(App).use(store).use(router)

function callbackRedirect(appState) {
  router.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : '/'
  );
}

setupAuth(appConfig.auth0, callbackRedirect).then((auth) => {
  app.use(auth).mount('#app')
})

